export default __webpack_public_path__ + "static/customization-f4e568cd4c9b04c766ae782975f1a72a.png";